export const APP_SITE_KEY = import.meta.env.VITE_APP_SITE_KEY;
import { useImperativeHandle, Ref, forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import useRecaptcha from "./useRecaptcha";

interface CaptchaProps {
  ref: Ref<CaptchaRef>;
  onVerify: (isValid: ICaptchaValid) => void;
}
export type CaptchaRef = {
  resetCaptcha: () => void;
};

const Captcha = forwardRef<CaptchaRef, CaptchaProps>(({ onVerify }, ref) => {
  const { recaptchaRef, handleRecaptcha } = useRecaptcha();

  useImperativeHandle(ref, () => ({
    resetCaptcha: async () => {
      onVerify({ valid: false, value: "" });
      recaptchaRef.current?.reset();
    },
  }));

  const handleCheck = async () => {
    const captchaValue = recaptchaRef.current?.getValue();
    if (!captchaValue) {
    }

    const isValid: boolean = captchaValue !== undefined && captchaValue !== "";

    handleRecaptcha(captchaValue ?? null);

    onVerify({ valid: isValid, value: captchaValue ?? "" });
  };

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={APP_SITE_KEY}
      onChange={handleCheck}
    />
  );
});

export default Captcha;
